import React from 'react';
import Field from '../Form/Field';
import ShowField from '../Field_Components/ShowField/ShowField';
import * as stateUtil from '../util/componetState';
import * as uiUtil from '../util/ui';
import * as html from '../util/html';
import { getExtensionCmp } from '../util/extension';
import { getStyleTitleByLang } from '../util/helper';

class SubComponents extends React.Component {
    constructor(props) {
        super(props);
    }

    getFieldProperty(field_name, property) {
        // searchForm从tempSearchData下取数据
        if (this.props.cmp_type == 'SearchForm') {
            if (
                this.props.tempSearchData &&
                this.props.tempSearchData.hasOwnProperty(field_name) &&
                this.props.tempSearchData[field_name].hasOwnProperty(property)
            ) {
                return this.props.tempSearchData[field_name][property];
            }
            return '';
        }
        // form从biz_data下取数据
        if (
            this.props.biz_data &&
            this.props.biz_data.hasOwnProperty(field_name) &&
            this.props.biz_data[field_name].hasOwnProperty(property)
        ) {
            return this.props.biz_data[field_name][property];
        }
        return '';
    }

    getFieldBizData(biz_data, field_name) {
        if (biz_data && biz_data[field_name]) {
            return biz_data[field_name];
        }
        return {};
    }

    // 有些字段需要格式化
    getValue(cmp, text) {
        switch (cmp) {
            case 'BC_TextAreaRTF':
                return html.decode(text);
            case 'BC_UserSelect':
                return uiUtil.extractUserName(text);
            default:
                return text;
        }
    }

    getSubComponents() {
        const {
            componentMap,
            biz_data,
            tempSearchData,
            sub_cmps,
            onChangeInfo,
            cmp_data,
            styleTitle
        } = this.props;
        // 有 subComponents 包含 subComponents 的情况，此时有效值为 styleTitle,在最外一层，styleTitle 从cmp_data中获取(只取英文参数)，之后都为styleTitle
        const formStyleTitle = styleTitle  || getStyleTitleByLang(cmp_data && cmp_data.styleTitleEN);
        let oneFormpart =
            sub_cmps.length == 1 && sub_cmps[0].cmp_type == 'FormPart';
        return sub_cmps.map((cmp, index) => {
            if (cmp.cmp_type === 'ButtonList') {
                //ButtonList由每个包含它的组件进行实例化
                return null;
            }
            let DestComponent =
                getExtensionCmp(cmp) ||
                componentMap.getComponentMap(
                    cmp.search_data ? cmp.search_data.opeartor : ''
                )[cmp.cmp_type];

            // 字段可扩展
            let FiedComponent = getExtensionCmp(cmp) || ShowField;
            if (!DestComponent) {
                return null;
            }
            const { cmp_id, cmp_type } = cmp;
            const field_NAME =
                this.props.isMultiForm && cmp.cmp_data.field_name_for_multi
                    ? cmp.cmp_data.field_name_for_multi
                    : cmp.cmp_data.field_name;
            if (cmp_type === 'BC_UserSelect') {
                cmp.avatars = (this.props.cmp_type == 'SearchForm'
                    ? tempSearchData
                    : biz_data)[cmp.cmp_data.field_name];
            }

            const errorMessage = field_NAME
                ? this.props.form_errors[field_NAME]
                : { error: false, message: '' };
            if (cmp.sub_cmps && cmp.sub_cmps.length > 0) {
                return (
                    <DestComponent
                        ref={cmp_id}
                        key={cmp_id}
                        biz_data={biz_data}
                        {...cmp}
                        formType={this.props.formType}
                        form_context={this.props.form_context}
                        containerContext={this.props.containerContext}
                        componentMap={this.props.componentMap}
                        actions={this.props.actions}
                        form_state={this.props.form_state}
                        form_id={this.props.form_id}
                        form_errors={this.props.form_errors}
                        onChange={this.props.onChange}
                        onChangeInfo={onChangeInfo}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        errorScrollInToView={this.props.errorScrollInToView}
                        onClick={this.props.onClick}
                        container_type={
                            this.props.container_type || this.props.cmp_type
                        }
                        oneFormpart={oneFormpart}
                        onClose={this.props.onClose}
                        synBizData={this.props.synBizData}
                        handleCancel={this.props.handleCancel}
                        handleClosePopUp={this.props.handleClosePopUp}
                        visible={this.props.visible}
                        isMultiForm={this.props.isMultiForm}
                        getRefreshParams={this.props.getRefreshParams}
                        styleTitle={formStyleTitle}
                    />
                );
            }
            let field_name =
                this.props.isMultiForm && cmp.cmp_data.field_name_for_multi
                    ? cmp.cmp_data.field_name_for_multi
                    : cmp.cmp_data.field_name;

            if (this.props.cmp_type == 'SearchForm') {
                field_name = cmp.cmp_data.biz_data_key;
            }
            const text = html.decode(this.getFieldProperty(field_name, 'text'));
            const value = html.decode(
                this.getFieldProperty(field_name, 'value')
            );
            const cmp_biz_data = this.getFieldBizData(
                this.props.cmp_type == 'SearchForm' ? tempSearchData : biz_data,
                field_name
            );

            // 除附件以外的组件  详情页组件 都展示为showField‘
            const specialDetailCmp = 'BC_FileUploader,BC_PictureUploader';
            const showField =
                this.props.formType === 'detailForm' &&
                specialDetailCmp.indexOf(cmp_type) < 0 &&
                this.props.cmp_type == 'FormPart';
            // 组件特殊的样式
            const showFieldCls = {
                BC_TextAreaRTF: 'rich_eidtor_showfield edui-container'
            };
            // 详情页字段链接
            const linkId = cmp.cmp_data.isLink
                ? this.props.biz_data[field_name] &&
                  this.props.biz_data[field_name].value
                : '';

            const label = cmp.cmp_label || '';
            let required = cmp.cmp_data.required ? true : false;
            let promptmessage =
                this.props.formType == 'detailForm' ||
                stateUtil.isReadOnly(cmp.cmp_data)
                    ? null
                    : html.decode(cmp.cmp_data.promptmessage) || null;
            let desc =
                this.props.formType == 'detailForm'
                    ? null
                    : html.decode(cmp.cmp_data.desc) || null;
            //判断是否渲染show状态组件
            let showRender = stateUtil.isReadOnly(cmp.cmp_data);
            let invisible = stateUtil.isInvisible(cmp.cmp_data);

            let cmp_relativeData = {
                field_name,
                cmp_id: cmp_id,
                num: cmp.cmp_data.num,
                isAllowedToSetRelationDataValue:
                    cmp.cmp_data.isAllowedToSetRelationDataValue
            };
            const singleLineCmpType = [
                'BC_TextBox',
                'BC_Email',
                'BC_DigitText',
                'BC_Url'
            ];
            if (invisible) {
                return null;
            } else {
              if(cmp.cmp_data.signFormat && cmp.cmp_data.isLink && cmp.cmp_data.linkURL) {
                cmp.cmp_data.linkURL = cmp.cmp_data.linkURL.endsWith('&') ? cmp.cmp_data.linkURL.concat(cmp.cmp_data.signFormat) : cmp.cmp_data.linkURL.concat('&' + cmp.cmp_data.signFormat);
              }
                return (
                    <Field
                        key={cmp_id}
                        cmp_relativeData={cmp_relativeData}
                        formType={this.props.formType}
                        onChange={this.props.onChange}
                        onBlur={this.props.onBlur}
                        errorScrollInToView={this.props.errorScrollInToView}
                        onFocus={this.props.onFocus}
                        validators={this.props.validators}
                        field_name={field_name}
                        promptmessage={
                            singleLineCmpType.indexOf(cmp_type) !== -1 &&
                            this.props.cmp_type !== 'SearchForm'
                                ? promptmessage
                                : ''
                        }
                        container_type={
                            this.props.container_type || this.props.cmp_type
                        }
                        getRefreshParams={this.props.getRefreshParams}
                        >
                        {showField ? (
                            <FiedComponent
                                cls={showFieldCls[cmp_type] || ''}
                                text={label || ''}
                                value={this.getValue(cmp_type, text)}
                                cmpType={cmp_type}
                                form_context={this.props.form_context}
                                bizData={this.props.biz_data}
                                isLink={cmp.cmp_data.isLink || false}
                                linkURL={cmp.cmp_data.linkURL || ''}
                                id={linkId || ''}
                                OpenTarget={cmp.cmp_data.OpenMode}
                                refMetaObjectName={
                                    cmp.cmp_data.refMetaObjectName || ''
                                }
                                metaObjectName={
                                    cmp.cmp_data.metaObjectName || ''
                                }
                                styleTitle={formStyleTitle}
                            />
                        ) : (
                            <DestComponent
                                formType={this.props.formType}
                                isReadOnly={showRender}
                                cmp_type={cmp_type}
                                cmpData={cmp.cmp_data}
                                onChangeInfo={this.props.onChangeInfo}
                                form_state={this.props.form_state}
                                form_id={this.props.form_id}
                                {...cmp}
                                isSearchList={this.props.isSearchList}
                                label={label}
                                {...cmp_biz_data}
                                componentMap={this.props.componentMap}
                                actions={this.props.actions}
                                form_context={this.props.form_context}
                                text={text}
                                value={value}
                                required={required}
                                desc={desc}
                                field_name={field_name}
                                errorMessage={errorMessage}
                                searchParams={
                                    (this.props.cmp_type == 'SearchForm'
                                        ? this.props.tempSearchData
                                        : this.props.biz_data)[field_name]
                                }
                                container_type={
                                    this.props.container_type ||
                                    this.props.cmp_type
                                }
                                pop_type={this.props.pop_type}
                                synBizData={this.props.synBizData}
                                onClose={this.props.onClose}
                                onChange={this.props.onChange}
                                handleCancel={this.props.handleCancel}
                                handleClosePopUp={this.props.handleClosePopUp}
                                visible={this.props.visible}
                                getRefreshParams={this.props.getRefreshParams}
                                styleTitle={formStyleTitle}
                            />
                        )}
                    </Field>
                );
            }
        });
    }

    render() {
        return (
            <div className='form_part_com_padding'>
                {this.getSubComponents()}{' '}
            </div>
        );
    }
}

export default SubComponents;



// WEBPACK FOOTER //
// ./src/components/Common/SubComponent.js